import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles(theme => ({
  root: {
    minHeight: '20rem',
    padding: '0.5rem',
    background: neutral.white,
    [theme.breakpoints.up('md')]: {
      padding: '19px 24px',
    },
  },
  restaurantImg: {
    height: '5rem',
    width: '5rem',
  },
  releaseRtButton: {
    float: 'left',
    width: '104px',
    marginLeft: '22px',
    marginTop: '-56px',
  },
}));
